<template src="./DtTable.html"></template>
<script>
  export default {
    data () {
      return {}
    },
    props: ['id', 'header', 'data'],
    methods: {
      edit (row) {
        this.$emit('edit', row)
      },
      remove (row) {
        this.$emit('delete', row)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/ui/table/DtTable.vue